import { Injectable } from '@angular/core';
import { ICommonService } from './iapp.config';

@Injectable({
  providedIn: 'root',
})
export class CommonService implements ICommonService {
  constructor() {}

  public getRequestHeader = () => {
    const header = {
     //'Content-Type': 'application/json',
      
    };
    return header;
  };
  public getRequestFileHeader = () => {
    const header = {
      Authorization: '',
    };
    return header;
  };
}
